import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconAutomatic } from '../../../../../../assets/icons/icon-automatic';
import { ChannelTypeInternal } from '../../../../../../data-access/gql-types/graphql';
import { useCover } from '../../../../hooks/cover';
import { useGate } from '../../../../hooks/gate';
import { useChannelsStateStore } from '../../../../store/channels-state';
import { ChannelCoverStateType, ChannelGateStateType, ChannelType } from '../../../../types';
import { useConfiguration } from '../../../channel-configuration/hooks/use-configuration';

type CalibrationProps = {
  channel: ChannelType;
};

export const Calibration: React.FC<CalibrationProps> = <T extends ChannelCoverStateType | ChannelGateStateType>({
  channel,
}) => {
  const { t } = useTranslation('channel-settings');
  const { t: tcd } = useTranslation('channel-details');
  const { t: tc } = useTranslation('common');
  const { autoCalibrate, calibrateLoading } = useConfiguration({ channel });
  const state = useChannelsStateStore((s) => s.channelState[channel.id]) as T | null;
  const { handleAction: handleBlindAction } = useCover(channel);
  const { handleAction: handleGateAction } = useGate(channel);
  const calibrationInProgress = state?.calibrateState?.progress;

  const handleAction = () => {
    if (channel.data.type === ChannelTypeInternal.Blind) {
      handleBlindAction('stop');
    } else if (channel.data.type === ChannelTypeInternal.Gate) {
      handleGateAction('stop');
    }
  };

  if (calibrationInProgress) {
    return (
      <>
        <button onClick={handleAction} className="button button--secondary button--active-on-click">
          {tc('status.stop')}
        </button>
        <p>{`${tcd('calibrationProgress')} ${state?.calibrateState?.progress}%`}</p>
      </>
    );
  }

  return (
    <div className="max-width-desktop">
      <button onClick={autoCalibrate} className="button button--secondary button--active-on-click">
        <IconAutomatic />
        {!calibrateLoading ? t('automatic') : tc('buttons.loading')}
      </button>
    </div>
  );
};
